import * as React from 'react';

import { Link } from '../../common/components/link';
import * as styles from './index.css';

export interface IDemolishedInMoscowProgrammProps {
  demolishedInMoscowProgramm: boolean | null;
}

export function DemolishedInMoscowProgramm(props: IDemolishedInMoscowProgrammProps) {
  if (!props.demolishedInMoscowProgramm) {
    return null;
  }

  return (
    <blockquote className={styles['container']}>
      <h4 className={styles['title']}>Дом под снос</h4>
      <p className={styles['text']}>
        По результатам голосования жильцов дом включен в
        <Link href={`/magazine/?tag=${encodeURIComponent('реновация')}`} target="_blank">
          {' '}
          программу реновации{' '}
        </Link>
        и будет снесен
      </p>
    </blockquote>
  );
}
